import type { EntityConfig } from "@/v2/framework/registry/types";
import { createMarketsView } from "./grid/view";

export default {
  id: "markets",
  name: "markets",
  title: "metadata.markets",
  position: 5,
  create: (ctx) => createMarketsView(ctx),
} satisfies EntityConfig;
